import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-social-media-thank-you',
  templateUrl: './social-media-thank-you.component.html',
  styleUrls: ['./social-media-thank-you.component.scss'],
})
export class SocialMediaThankYouComponent implements OnInit {
  agencyName: string = '';

  ngOnInit(): void {
    // Read agency name (if present) BEFORE clearing storage so we can personalise the message.
    try {
      const agencyJson = sessionStorage.getItem('socialMediaAgency');
      if (agencyJson) {
        const agency = JSON.parse(agencyJson);
        this.agencyName = agency?.FirmName || '';
      }
    } catch {
      this.agencyName = '';
    }

    // Terminal page: no auth, nothing to navigate to. Wipe any session/local data so the
    // customer cannot reach any Senem RFP / login / signup page from here.
    try {
      sessionStorage.clear();
      localStorage.clear();
    } catch {
      /* storage may be unavailable in private mode - ignore */
    }

    // Block the browser Back button from leaving this terminal screen.
    history.pushState(null, '', location.href);
    window.addEventListener('popstate', this.blockBack);
  }

  private blockBack = () => {
    history.pushState(null, '', location.href);
  };

  closeWindow(): void {
    // window.close() only works for script-opened tabs; the social media flow opens the
    // registration in the same tab, so we also show guidance text as a fallback.
    window.open('', '_self');
    window.close();
  }

  ngOnDestroy(): void {
    window.removeEventListener('popstate', this.blockBack);
  }
}
